import DeleteRemitAddressContainer from "./DeleteRemitAddressContainer";
export default DeleteRemitAddressContainer;
